<template lang="pug">
v-col(cols="12" lg="8").mx-auto
  v-card(flat v-if="!loading").overflow-hidden
    v-card-title: h4 {{questionnaire.name}}
    v-card-subtitle {{ questionnaire.description }}
    v-card-text.pt-4
      v-col(cols="4").ml-auto
        .d-flex
          span.primary--text {{ progressData.count }}/{{questionnaire.questions.length}}
          v-spacer
          span.primary--text {{progressData.percent}}%
        v-progress-linear(
          :value="progressData.percent"
          color="primary"
          rounded height="8"
        )
      v-card(height="60vh" flat)
        v-window(
          v-model="flickingModel"
          vertical
        )
          v-window-item(
            v-for="(question, idx) in questionnaire.questions"
          )
            v-card(
              flat outlined
            )
              v-card-title
                span.primary--text.mr-2 {{ idx + 1 }}.
                span {{ question.name }}
              v-card-subtitle {{ question.description }}
              v-card-text
                component(
                  :is="INPUT_FIELDS[question.type](question).component"
                  v-bind="INPUT_FIELDS[question.type](question, formAnswers[question.id]).props"
                  :label="INPUT_TEXT[question.type]"
                  rounded outlined
                  :value="formAnswers[question.id].answer"
                  :key="`${formAnswers[question.id].id}-${idx}`"
                  @change="saveAnswer($event, question.id, question.type)"
                )
                  template(
                    #default="{ uploadCropped, loading, prev }"
                    v-if="question.type === INPUTS.images"
                  )
                    v-btn(outlined color="primary" @click="prev") Редактировать
                    v-spacer
                    v-btn(
                      rounded color="success"
                      :loading="loading"
                      @click="uploadCropped"
                    ) Сохранить
              v-card-actions
                v-btn.px-4(
                  v-if="idx !== 0"
                  color="primary"
                  rounded outlined
                  @click="handleWindowPage(-1)"
                ) Назад
                v-btn.ml-auto.px-4(
                  v-if="(idx+1) !== questionnaire.questions.length"
                  color="primary"
                  rounded
                  @click="handleWindowPage(1)"
                ) Следующий
                v-btn.ml-auto.px-4(
                  v-else
                  color="success" rounded @click="openSave" :loading="loadingBtn"
                ) Отправить
            //- v-list-item-avatar.mt-4.white--text.absolute.align-self-start(
            //-   color="primary" size="24" outlined
            //-   style="top: 0"
            //- ) {{idx +1 }}
            //- v-list-item-content
            //-   p.text-body-1 {{ question.name }}
            //-   p.text-body-2 {{ question.description }}
            //-   component(
            //-     :is="INPUT_FIELDS[question.type](question).component"
            //-     v-bind="INPUT_FIELDS[question.type](question).props"
            //-     :label="INPUT_TEXT[question.type]"
            //-     rounded outlined
            //-     :value="formAnswers[question.id].answer"
            //-     :key="`${formAnswers[question.id].id}-${idx}`"
            //-     @change="saveAnswer($event, question.id)"
            //-   )
</template>
<script>
import FileInput from '@/components/InputFields/FileInput.vue';
import ImageCropper from '@/components/InputFields/imageCropper.vue';

const INPUTS = {
  slider: 1,
  text: 2,
  document: 3,
  images: 4,
  variant: 5,
  url: 6,
};
const INPUT_TEXT = {
  [INPUTS.slider]: '',
  [INPUTS.text]: 'Введите ответ',
  [INPUTS.document]: 'Загрузите документ',
  [INPUTS.images]: 'Загрузите изображение',
  [INPUTS.variant]: 'Выберете вариант из списка',
  [INPUTS.url]: 'Введите ссылку',
};

const INPUT_FIELDS = {
  [INPUTS.slider]: ({ slider_min: min, slider_max: max }) => ({
    component: 'v-slider',
    props: {
      min,
      max,
    },
  }),
  [INPUTS.text]: () => ({
    component: 'v-textarea',
  }),
  [INPUTS.document]: () => ({
    component: FileInput,
  }),
  [INPUTS.images]: () => ({
    component: ImageCropper,
    props: {
      showSaveButton: true,
    },
  }),
  [INPUTS.variant]: ({ question_variants: items }) => ({
    component: 'v-select',
    props: {
      items,
      multiple: true,
      'item-text': 'name',
      'item-value': 'id',
    },
  }),
  [INPUTS.url]: ({ question_variants: items }) => ({
    component: 'v-text-field',
    props: {
      items,
    },
  }),
};

export default {
  data() {
    return {
      flickingModel: 0,
      INPUTS,
      INPUT_FIELDS,
      INPUT_TEXT,
      loading: true,
      loadingBtn: false,
      formAnswers: {},
    };
  },
  computed: {
    progressData() {
      const perPercent = 100 / this.questionnaire.questions.length;
      const count = Object.values(this.formAnswers)
        .reduce((acc, { id }) => (id ? acc + 1 : acc), 0);
      const percent = Math.ceil(perPercent * count);
      return { percent, count };
    },
  },
  async created() {
    const response = await this.$api.mentoring.showQuestionnaireForms(this.$route.params.id);
    const { data } = await this.$api.mentoring.showQuestionnaires(response.data.data.questionnaire_id, { expand: 'questions' });
    this.questionnaire = data.data;
    this.getAnswers();
  },
  methods: {
    setWindowPage() {
      const { count } = this.progressData;
      this.flickingModel = count - 1;
    },
    handleWindowPage(val) {
      this.flickingModel += val;
    },
    async getAnswers() {
      const params = {
        'search[questionnaire_form_id]': this.$route.params.id,
        expand: 'document,images',
      };
      const { data } = await this.$api.mentoring.getFormAnswer(params);
      const answers = data.data;
      this.formAnswers = this.questionnaire.questions.reduce((acc, cur) => {
        const answer = answers?.find(({ question_id: qId }) => qId === cur.id);
        return {
          ...acc,
          [cur.id]: {
            id: answer?.id || null,
            answer: answer?.answer || answer?.document || answer?.images[0] || null,
          },
        };
      }, {});
      this.setWindowPage();
      this.loading = false;
    },
    serializeAnswerByType(answer, type) {
      const sirializer = {
        [INPUTS.slider]: (val) => val,
        [INPUTS.text]: (val) => val,
        [INPUTS.document]: (val) => ({ name: val, original_name: val }),
        [INPUTS.images]: (val) => [val],
        [INPUTS.variant]: (val) => val,
        [INPUTS.url]: (val) => val,
      };
      return sirializer[type](answer);
    },
    async saveAnswer(value, id, type) {
      this.loadingBtn = true;
      const answer = this.serializeAnswerByType(value, type);
      const payload = {
        questionnaire_form_id: this.$route.params.id,
        question_id: id,
        answer,
      };
      // refactor this
      if (this.formAnswers[id].id) {
        await this.$api.mentoring.updateFormAnswer(
          this.formAnswers[id].id,
          payload,
        );
      } else {
        const { data } = await this.$api.mentoring.createFormAnswer(payload);
        this.$set(this.formAnswers[id], 'id', data.data.id);
      }
      this.$set(this.formAnswers[id], 'answer', answer);
      this.loadingBtn = false;
    },
    openSave() {
      this.$modals.show('confirm-controller', {
        title: 'Подтвердите отправку анкеты',
        method: async () => {
          const payload = { is_complete: 1 };
          await this.$api.mentoring.updateQuestionnaireForms(this.$route.params.id, payload);
          this.$router.push({ name: 'Mentored' });
        },
      });
    },
  },
};
</script>
